/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Benefit_Billing_TitleInputs */

const en_home_benefit_billing_title = /** @type {(inputs: Home_Benefit_Billing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direct Billing`)
};

const fr_home_benefit_billing_title = /** @type {(inputs: Home_Benefit_Billing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturation directe`)
};

/**
* | output |
* | --- |
* | "Direct Billing" |
*
* @param {Home_Benefit_Billing_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_benefit_billing_title = /** @type {((inputs?: Home_Benefit_Billing_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Benefit_Billing_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_benefit_billing_title(inputs)
	return fr_home_benefit_billing_title(inputs)
});